import { useState } from "react"
import { SwiperSlide } from "swiper/react"
import { motion } from "framer-motion"
import { Image } from "@components/anti/Image"
import { SliderSwiper } from "@components/anti/Slider/Swiper"
import IndonesianMaps from "@components/global/IndonesianMaps"
import SwiperNavigation from "@components/global/SwiperNavigation"
import { translations } from "src/helper/translations"
import { useCustomNavSwiper, useScrollAnim } from "src/hooks/hooks"
import { convertJson, imgUrl } from "src/mixins"

function HomeLocation({ data, locale }) {
  const [trigger, anim] = useScrollAnim()
  // const [swiperRef, handlePrev, handleNext, index] = useCustomNavSwiper()
  const listLocation = convertJson(data.items)

  const [activeIsland, setActiveIsland] = useState(0)
  const handlePrev = () => {
    setActiveIsland(
      activeIsland - 1 < 0 ? listLocation.length - 1 : activeIsland - 1
    )
  }
  const handleNext = () => {
    setActiveIsland(
      activeIsland + 1 > listLocation.length - 1 ? 0 : activeIsland + 1
    )
  }
  return (
    <section className="sc-home-location" ref={trigger}>
      <div className="bg" />
      <div className="py-main">
        <div className="container-fluid container-md">
          <div className="row align-items-center">
            <div className="col-sm-5 col-title">
              <h2 className={`title ${anim(1)}`}>
                {data && data[`title_${locale}`]}
              </h2>
              <div className="d-none d-sm-block">
                <motion.div
                  key={activeIsland}
                  initial={{ opacity: 0.1 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0.1 }}
                  transition={{ duration: 0.15 }}
                  className="location-data"
                >
                  <h5 className={`title ${anim(3)}`}>
                    {locale === "id"
                      ? listLocation[activeIsland]?.province
                      : listLocation[activeIsland]?.province_en}
                  </h5>
                  <div className="location-data_content">
                    <div className="item">
                      <h4 className={`value ${anim(5)}`}>
                        {listLocation[activeIsland]?.layar}
                      </h4>
                      <p className={`label ${anim(7, "fadeInUp7")}`}>
                        {translations[`screen_${locale}`]}
                      </p>
                    </div>
                    <div className="item">
                      <h4 className={`value ${anim(9)}`}>
                        {listLocation[activeIsland]?.lokasi}
                      </h4>
                      <p className={`label ${anim(12, "fadeInUp7")}`}>
                        {translations[`location_${locale}`]}
                      </p>
                    </div>
                  </div>
                </motion.div>
                <SwiperNavigation
                  handlePrev={handlePrev}
                  handleNext={handleNext}
                  theme="dark"
                />
              </div>
            </div>
            <div className="col-sm-7 col-slider">
              <IndonesianMaps
                active={activeIsland}
                setActive={setActiveIsland}
              />
            </div>
            <div className="col-12">
              <div className="d-block d-sm-none">
                <motion.div
                  className="location-data"
                  key={activeIsland}
                  initial={{ opacity: 0.1 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0.1 }}
                  transition={{ duration: 0.15 }}
                >
                  <h5 className={`title ${anim(3)}`}>
                    {listLocation[activeIsland]?.province}
                  </h5>
                  <div className="location-data_content">
                    <div className="item">
                      <h4 className={`value ${anim(5)}`}>
                        {listLocation[activeIsland]?.layar}
                      </h4>
                      <p className={`label ${anim(7, "fadeInUp7")}`}>
                        {translations[`screen_${locale}`]}
                      </p>
                    </div>
                    <div className="item">
                      <h4 className={`value ${anim(6)}`}>
                        {listLocation[activeIsland]?.lokasi}
                      </h4>
                      <p className={`label ${anim(7, "fadeInUp7")}`}>
                        {translations[`location_${locale}`]}
                      </p>
                    </div>
                    {/* <div className="item">
                      <h4 className="value">{listLocation[activeIsland]?.kota}</h4>
                      <p className="label">{translations[`city_${locale}`]}</p>
                    </div> */}
                  </div>
                </motion.div>
                <SwiperNavigation
                  handlePrev={handlePrev}
                  handleNext={handleNext}
                  theme="dark"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeLocation
